export default __webpack_public_path__ + "static/media/ruby.9949ca2f.svg";